import styled from 'styled-components'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const Columns = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};

  & > * {
    flex: 1;
  }

  @media (max-width: 1120px) {
    gap: ${props => props.theme.spacing.sp8};
  }
`
